"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const DEFAULT_STORAGE_KEY = "aircasting:recent-searches";
const DEFAULT_CAPACITY = 5;
const isValidRecent = (value) => {
    if (!value || typeof value !== "object")
        return false;
    const candidate = value;
    return (typeof candidate.id === "string" &&
        typeof candidate.label === "string" &&
        typeof candidate.lat === "number" &&
        typeof candidate.lng === "number" &&
        typeof candidate.zoom === "number");
};
const readFromStorage = (storageKey) => {
    if (typeof window === "undefined")
        return [];
    try {
        const raw = window.localStorage.getItem(storageKey);
        if (!raw)
            return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed.filter(isValidRecent);
    }
    catch (_a) {
        return [];
    }
};
const writeToStorage = (storageKey, value) => {
    if (typeof window === "undefined")
        return;
    try {
        window.localStorage.setItem(storageKey, JSON.stringify(value));
    }
    catch (_a) {
        // localStorage quota exceeded or unavailable — silently skip
    }
};
const useRecentSearches = (options = {}) => {
    const { storageKey = DEFAULT_STORAGE_KEY, capacity = DEFAULT_CAPACITY } = options;
    const [recents, setRecents] = (0, react_1.useState)(() => readFromStorage(storageKey));
    (0, react_1.useEffect)(() => {
        setRecents(readFromStorage(storageKey));
    }, [storageKey]);
    (0, react_1.useEffect)(() => {
        writeToStorage(storageKey, recents);
        // Intentionally omit storageKey: when the key changes we reload recents first;
        // this effect runs again after that state update with the new key in closure.
    }, [recents]);
    const addRecent = (0, react_1.useCallback)((item) => {
        setRecents((previous) => {
            const withoutDuplicate = previous.filter((r) => r.id !== item.id);
            const next = [item, ...withoutDuplicate];
            return next.slice(0, capacity);
        });
    }, [capacity]);
    const clearRecents = (0, react_1.useCallback)(() => {
        setRecents([]);
    }, []);
    return { recents, addRecent, clearRecents };
};
exports.default = useRecentSearches;
